module.exports = __webpack_public_path__ + "img/warning.94911415.svg";